import { onMounted, resolveComponent, createElementBlock, openBlock, createElementVNode, createVNode, unref, Fragment, isRef, withCtx, createBlock, toDisplayString } from "vue";
import RecursiveDraggableMenu from "./RecursiveDraggableMenu.vue.js";
import _sfc_main$1 from "./NavigationMenuEditCard.vue.js";
import { NAVIGATION_MENU_FOR_EDIT, ADD_OR_EDIT_NAVIGATION_MENU } from "../../graphql/navigation-menu.js";
import "../../plugins/apollo.js";
import "lodash-es";
import "moment";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import "../../plugins/i18n.js";
import "../../assets/e94e4817134d7c25.png";
import "../../assets/5341da3ffbec0137.png";
import "../../assets/01f50022317dccd7.png";
import "axios";
import "vue-router";
import "maska";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                  */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css                     */
import { VSkeletonLoader } from "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                               */
import { VContainer } from "vuetify/components/VGrid";
import "../Base/index.js";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../icons/mdi/index.js";
/* empty css                            */
import "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                      */
import "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                        */
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
import "../../graphql/system-settings.js";
import { useEmitter } from "../../plugins/banza/emitter.js";
/* empty css                             */
/* empty css                                    */
import "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                            */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                                             */
/* empty css                          */
import "graphql-tag";
import "../../graphql/entity.js";
import "../../graphql/lookups.js";
/* empty css                       */
import "vuetify/components";
/* empty css                             */
/* empty css                     */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                         */
import "vuetify/components/VTooltip";
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
/* empty css                            */
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
/* empty css                    */
import "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
/* empty css                        */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                                           */
/* empty css                               */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                  */
import "vuetify/components/VItemGroup";
/* empty css                             */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                        */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import "../../graphql/session-store.js";
import "../../composables/useModalPage.js";
import "../../icons/portal/index.js";
import { useRecursiveDraggableMenu } from "../../composables/useRecursiveDraggableMenu.js";
const _hoisted_1 = { class: "b-navigation-menu__editor d-flex flex-nowrap pa-4 w-100 ga-4" };
const _hoisted_2 = { class: "b-navigation-menu__draggable d-flex flex-column align-center flex-shrink-0 g-2 pa-3 rounded-xl" };
const _hoisted_3 = { class: "b-navigation-menu__controls d-flex justify-center" };
const _hoisted_4 = { class: "b-navigation-menu__controls d-flex justify-end g-2" };
const _hoisted_5 = {
  key: 1,
  class: "d-flex justify-center align-center pa-4"
};
const _sfc_main = {
  __name: "NavigationMenu",
  props: {
    usePages: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const emitter = useEmitter();
    const {
      items,
      selectedItem,
      hasChanges,
      loading,
      saving,
      load,
      reload,
      addItem,
      deleteItem,
      save
    } = useRecursiveDraggableMenu({
      query: NAVIGATION_MENU_FOR_EDIT,
      mutation: ADD_OR_EDIT_NAVIGATION_MENU,
      diffConfig: {
        experimental: {
          hasDeletedProp: true
        }
      },
      onBeforeSave: (inputs) => {
        inputs.forEach((el) => {
          if (el.hasOwnProperty("icon") && !el.icon) {
            el.icon = "";
          }
        });
      },
      onAfterSave: () => {
        emitter.emit("reload-navigation-menu");
      }
    });
    onMounted(load);
    return (_ctx, _cache) => {
      const _component_b_btn = resolveComponent("b-btn");
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("div", _hoisted_2, [
          unref(loading) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createVNode(VSkeletonLoader, {
              class: "banza-skeleton mb-1",
              height: 42,
              width: 250,
              type: "list-item"
            }),
            createVNode(VSkeletonLoader, {
              class: "banza-skeleton mb-1",
              height: 42,
              width: 250,
              type: "list-item"
            }),
            createVNode(VSkeletonLoader, {
              class: "banza-skeleton mb-1",
              height: 42,
              width: 250,
              type: "list-item"
            }),
            createVNode(VSkeletonLoader, {
              class: "banza-skeleton mb-1",
              height: 42,
              width: 250,
              type: "list-item"
            })
          ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createElementVNode("div", _hoisted_3, [
              createVNode(_component_b_btn, {
                preset: "add",
                text: _ctx.$t("base.labels.add_new_item"),
                onClick: unref(addItem)
              }, null, 8, ["text", "onClick"])
            ]),
            createVNode(RecursiveDraggableMenu, {
              class: "b-navigation-menu__draggable__items",
              "selected-item": unref(selectedItem),
              "onUpdate:selectedItem": _cache[0] || (_cache[0] = ($event) => isRef(selectedItem) ? selectedItem.value = $event : null),
              items: unref(items),
              "onUpdate:items": _cache[1] || (_cache[1] = ($event) => isRef(items) ? items.value = $event : null),
              "group-name": "navigation-menu",
              "is-root": true
            }, null, 8, ["selected-item", "items"]),
            createElementVNode("div", _hoisted_4, [
              createVNode(_component_b_btn, {
                preset: "cancel",
                disabled: !unref(hasChanges),
                onClick: unref(reload)
              }, null, 8, ["disabled", "onClick"]),
              createVNode(_component_b_btn, {
                preset: "save",
                loading: unref(saving),
                disabled: !unref(hasChanges),
                onClick: unref(save)
              }, null, 8, ["loading", "disabled", "onClick"])
            ])
          ], 64))
        ]),
        createVNode(VContainer, { class: "b-navigation-menu__item flex-grow-1 pa-0 overflow-y-auto" }, {
          default: withCtx(() => [
            unref(selectedItem) ? (openBlock(), createBlock(_sfc_main$1, {
              key: 0,
              modelValue: unref(selectedItem),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => isRef(selectedItem) ? selectedItem.value = $event : null),
              "use-pages": __props.usePages,
              items: unref(items),
              onOnDelete: unref(deleteItem)
            }, null, 8, ["modelValue", "use-pages", "items", "onOnDelete"])) : (openBlock(), createElementBlock("div", _hoisted_5, toDisplayString(_ctx.$t("base.messages.select_menu_item_for_edit")), 1))
          ]),
          _: 1
        })
      ]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
